<template>
  <div class="row">
    <div class="columns small-9">
      <input
        :id="name"
        :value="modelValue"
        :disabled="loading"
        :name="name"
        type="text"
        @input="validateField($event.target.value)"
        @keyup.enter="enterPress"
      />
    </div>
    <div class="columns small-3">
      <button :disabled="loading || disabled" class="button" @click="$emit('change', true)">
        OK
      </button>
    </div>
  </div>
</template>

<script>
import FormComponentMixin from './_FormComponentMixin';
import '@/components/UI/ValidationError.vue';

export default {
  name: 'TextInput',
  mixins: [FormComponentMixin],
  mounted() {
    // document.getElementById(this.name).select();
  },
  methods: {
    enterPress() {
      if (!this.disabled) {
        this.$emit('change', true);
      }
    }
  }
};
</script>
